export default {
    navigationBarTitleText: '支付',
};
